"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var React = require("react");
var components_1 = require("@athena-portal/components");
var Notification_1 = require("./Notification");
var react_1 = require("@monaco-editor/react");
var CompareInteractionsModal = /** @class */ (function (_super) {
    __extends(CompareInteractionsModal, _super);
    function CompareInteractionsModal(props) {
        return _super.call(this, props) || this;
    }
    CompareInteractionsModal.prototype.render = function () {
        var _a = this.props, showComparedInteractions = _a.showComparedInteractions, interactionsLoaded = _a.interactionsLoaded, firstInteraction = _a.firstInteraction, secondInteraction = _a.secondInteraction, fallbackMessage = _a.fallbackMessage;
        return ((0, jsx_runtime_1.jsx)("div", { children: (0, jsx_runtime_1.jsx)(Notification_1.default, { show: showComparedInteractions, hide: this.props.hideComparedInteractions, title: "Compare Interactions", contentStyle: {
                    overflow: "visible",
                    position: "relative"
                }, body: (interactionsLoaded ? ((0, jsx_runtime_1.jsx)("div", { onClick: function (e) { return e.stopPropagation(); }, onFocus: function (e) { return e.stopPropagation(); }, onKeyDown: function (e) { return e.stopPropagation(); }, role: "none", style: {
                        height: "100%",
                        width: "100%",
                    }, children: (0, jsx_runtime_1.jsx)(react_1.DiffEditor, { language: "json", original: JSON.stringify(firstInteraction, null, 4), modified: JSON.stringify(secondInteraction, null, 4), keepCurrentOriginalModel: true, keepCurrentModifiedModel: true, onMount: function (editor) {
                            editor.focus();
                        } }) })) : (0, jsx_runtime_1.jsx)("p", { children: fallbackMessage })), style: {
                    maxHeight: "100%",
                    height: "100%",
                    margin: "0",
                    maxWidth: "100%",
                    width: "100%"
                }, fullscreen: true }) }));
    };
    CompareInteractionsModal = __decorate([
        components_1.authorize,
        __metadata("design:paramtypes", [Object])
    ], CompareInteractionsModal);
    return CompareInteractionsModal;
}(React.Component));
exports.default = CompareInteractionsModal;
//# sourceMappingURL=CompareInteractionsModal.js.map